export default "__VITE_ASSET__DYEh16ot__"